import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import './Standings.css'
import StatsAndStandingsHome from '../../shared/components/Navigation/StatsAndStandingsHome'
import StatsAndStandingsHomeNavigation from '../../shared/components/Navigation/StatsAndStandingsHomeNavigation'
//import { useHttpClient } from '../../shared/hooks/http-hook'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'

const Standings = () => {
	//const { sendRequest, clearError } = useHttpClient()
	const [error, setError] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [loadedStandings, setLoadedStandings] = useState()
	const [numberOfTeamsTotal, setNumberOfTeamsTotal] = useState()
	const [loadedStandingsArray, setLoadedStandingsArray] = useState([])
	const [leagueName, setLeagueName] = useState()
	const [divisionName, setDivisionName] = useState()
	const [session, setSession] = useState()
	const [year, setYear] = useState()
	const [masterArray, setMasterArray] = useState()
	//const [returnArray, setReturnArray] = useState([])

	const leagueId = useParams().leagueId

	console.log('inside Standings')

	//call to getStandings in the league-controller
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/leagues/${leagueId}/standings`,
				)

				const responseData = await response.json()

				/* console.log(
					'responseData here: ' + JSON.stringify(responseData.listOfTeams)
				) */

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				if (responseData.listOfTeams[0].divisionName) {
					setDivisionName(responseData.listOfTeams[0].divisionName)
				} else {
					setDivisionName('')
				}

				setMasterArray(responseData.masterMasterArray)
				setLoadedStandings(responseData.listOfTeams)
				setNumberOfTeamsTotal(responseData.numberOfTeamsTotal)
				setLoadedStandingsArray(responseData.listOfTeamsArray)
				setLeagueName(responseData.leagueName)
				setSession(responseData.session)
				setYear(responseData.year)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [leagueId])

	/* if (!isLoading && masterArray) {
		console.log('masterArray: ' + JSON.stringify(masterArray))
	} */

	let numberOfTeams
	//numberOfTeams = loadedStandings && loadedStandings.length
	//console.log('numberOfTeams: ' + loadedStandings)

	numberOfTeams = numberOfTeamsTotal && numberOfTeamsTotal.length
	console.log('numberOfTeamsTotal: ' + numberOfTeamsTotal)

	//So, when masterArray comes to us from the backend, it can be a pretty long list
	//if there were many sets of two teams tied for points.  For example, if there were
	//four sets of two teams tied in points, this masterarray would be four times the
	//size we need.  However, the last of those four would be the correct version.
	//So, we reverse the long incoming array, then cut it (splice it) at however many
	//number of teams there are, then we reverse it again.
	masterArray && masterArray.reverse()
	//console.log('masterArray 1: ' + masterArray)
	masterArray && masterArray.splice(numberOfTeamsTotal)
	//console.log('masterArray 2: ' + masterArray)
	masterArray && masterArray.reverse()
	//console.log('masterArray 3: ' + masterArray)
	//masterArray &&
	//	console.log('fucking master array: ' + JSON.stringify(masterArray))
	let groupedArray
	groupedArray = []
	if (masterArray) {
		const uniqueDivisionsArray = masterArray.map((item) => item.divisionName)

		const toFindUniques = (arry) =>
			arry.filter((item, index) => arry.indexOf(item) === index)

		const uniques = toFindUniques(uniqueDivisionsArray)

		console.log(
			'there are ' + uniques.length + ' divisions.  They are ' + uniques,
		)

		if (uniques.length > 1) {
			console.log(
				'we have more than one division, lets split them up into separate arrays',
			)
			for (const element of uniques) {
				const item = masterArray.filter((el) => el.divisionName === element)
				groupedArray.push(item)
			}
			/* groupedArray.forEach((array, index) => {
				console.log('groupedArray ' + index + ': ' + JSON.stringify(array))
			}) */
		}
	}
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	//
	if (groupedArray && groupedArray.length < 1) {
		return (
			<React.Fragment>
				<StatsAndStandingsHome />
				<StatsAndStandingsHomeNavigation leagueId={leagueId} />
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				{!isLoading && masterArray && (
					<div className='Roster'>
						<h1>League Standings</h1>
						<h1>
							{leagueName} {divisionName && ' - ' + divisionName + ' Division'}
						</h1>
						<h2>
							{session} {year}
						</h2>
						<p style={{ textAlign: 'center' }}>
							(Click on a team to go to their roster and schedule page)
						</p>
						<table id='roster' cellSpacing={'0'} cellPadding={'0'}>
							<thead>
								<tr>
									<th>Team</th>
									<th>GP</th>
									<th>W</th>
									<th>L</th>
									<th>T</th>
									<th>OTL</th>
									<th>SOL</th>
									<th>GF</th>
									<th>GA</th>
									<th>GD</th>
									<th>Points</th>
									<th>%</th>
								</tr>
							</thead>
							<tbody>
								{masterArray.map((team, key) => {
									return (
										<tr key={key}>
											<td className='tableDataTeamName'>
												<Link
													style={{
														textDecoration: 'none',
														// color: 'black',
														fontWeight: 600,
													}}
													to={`${session}/${year}/${team.teamName}`}
												>
													{team.teamName}
												</Link>
											</td>
											<td>
												{team.wins +
													team.losses +
													team.ties +
													team.shootoutLosses +
													team.overtimeLosses}
											</td>
											<td>{team.wins}</td>
											<td>{team.losses}</td>
											<td>{team.ties}</td>
											<td>{team.overtimeLosses}</td>
											<td>{team.shootoutLosses}</td>
											<td>{team.goalsFor}</td>
											<td>{team.goalsAgainst}</td>
											<td>{team.goalsFor - team.goalsAgainst}</td>
											<td>{team.points}</td>
											<td>
												{!isNaN(
													Number(
														(team.wins + team.ties * 0.5) /
															(team.wins +
																team.losses +
																team.overtimeLosses +
																team.shootoutLosses +
																team.ties),
													).toFixed(3),
												) &&
													Number(
														(team.wins + team.ties * 0.5) /
															(team.wins +
																team.losses +
																team.overtimeLosses +
																team.shootoutLosses +
																team.ties),
													).toFixed(3)}
											</td>
										</tr>
									)
								})}
							</tbody>
						</table>
					</div>
				)}
				{!isLoading && !masterArray && (
					<div className='Standings'>
						<h1>
							{leagueName} {divisionName && divisionName} - League Standings
						</h1>
						<h2>
							{session} {year}
						</h2>
						<table id='players' cellSpacing={'0'} cellPadding={'0'}>
							<thead>
								<tr>
									<th>Team</th>
									<th>GP</th>
									<th>W</th>
									<th>L</th>
									<th>T</th>
									<th>OTL</th>
									<th>SOL</th>
									<th>GF</th>
									<th>GA</th>
									<th>Points</th>
								</tr>
							</thead>
						</table>
					</div>
				)}
			</React.Fragment>
		)
	} else if (groupedArray && groupedArray.length > 0) {
		return (
			<React.Fragment>
				<StatsAndStandingsHome />
				<StatsAndStandingsHomeNavigation leagueId={leagueId} />
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				<h1>{leagueName} - Standings</h1>
				<h2>{year}</h2>
				{/* <h1>More than one group here. {groupedArray.length}</h1> */}
				{groupedArray.map((group, key) => {
					return (
						<div className='Roster'>
							<h4 style={{ textAlign: 'center' }}>
								{group[0].divisionName} Division
							</h4>
							<table id='roster' cellSpacing={'0'} cellPadding={'0'}>
								<thead>
									<tr>
										<th>Team</th>
										<th>GP</th>
										<th>W</th>
										<th>L</th>
										<th>T</th>
										<th>OTL</th>
										<th>SOL</th>
										<th>GF</th>
										<th>GA</th>
										<th>GD</th>
										<th>Points</th>
										<th>%</th>
									</tr>
								</thead>
								<tbody>
									{group.map((team, key) => {
										// return <h1>{team.teamName}</h1>
										return (
											<tr key={key}>
												<td className='tableDataTeamName'>
													<Link
														style={{
															textDecoration: 'none',
															// color: 'black',
															fontWeight: 600,
														}}
														to={`${team.divisionName}/${year}/${team.teamName}`}
													>
														{team.teamName}
													</Link>
												</td>
												<td>
													{team.wins +
														team.losses +
														team.ties +
														team.shootoutLosses +
														team.overtimeLosses}
												</td>
												<td>{team.wins}</td>
												<td>{team.losses}</td>
												<td>{team.ties}</td>
												<td>{team.overtimeLosses}</td>
												<td>{team.shootoutLosses}</td>
												<td>{team.goalsFor}</td>
												<td>{team.goalsAgainst}</td>
												<td>{team.goalsFor - team.goalsAgainst}</td>
												<td>{team.points}</td>
												<td>
													{!isNaN(
														Number(
															(team.wins + team.ties * 0.5) /
																(team.wins +
																	team.losses +
																	team.overtimeLosses +
																	team.shootoutLosses +
																	team.ties),
														).toFixed(3),
													) &&
														Number(
															(team.wins + team.ties * 0.5) /
																(team.wins +
																	team.losses +
																	team.overtimeLosses +
																	team.shootoutLosses +
																	team.ties),
														).toFixed(3)}
												</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					)
				})}
			</React.Fragment>
		)
	}
}

export default Standings
